//@ts-nocheck
import { memo, FunctionComponent } from "react";
import COLORS from "../../theme/Colors";
import { Container } from "./styles/CheckBoxStyles";
import { FieldTitle, Row } from "../../theme/Styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import CheckRender from "../CheckRender/CheckRender";

const CheckBox: FunctionComponent<propTypes> = (props) => {
  console.log(props.helperText);
  return (
    <Container>
      <Row>
        <FieldTitle>{props.title} </FieldTitle>
        <div style={{ width: "5px" }} />
        <CheckRender allowed={props.required}>
          <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
        </CheckRender>
      </Row>
      <FormControl
        disabled={props.disabled}
        required={props.required}
        error={props.error}
        component="fieldset"
        variant="standard"
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                size="medium"
                disabled={props.disabled}
                checked={props.value}
                onChange={props?.onChange}
                id={props.id}
              />
            }
            label={props.label ? props.label : ""}
          />
        </FormGroup>
        {props.helperText?.length > 0 && (
          <FormHelperText sx={{ fontSize: "0.90rem" }}>
            {props.helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Container>
  );
};

export interface propTypes {
  id: string;
  title?: string;
  label?: string;
  value: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  helperText?: string | boolean;
}

CheckBox.defaultProps = {
  helperText: "",
};

export default memo(CheckBox);
